import styled from "styled-components";
import {
  PRIMARY_COLOR,
  SEMI_BOLD_FONT,
  LIGHT_BACKGROUND_COLOR,
  QUERY_IPAD,
} from "@shared/constants";

export const NAV_BAR_HEIGHT = 70; // px
export const SIDE_BAR_EXTRA_HEIGHT = NAV_BAR_HEIGHT; // Extra height for spring animation
export const SIDE_BAR_HEIGHT = NAV_BAR_HEIGHT + 400 + SIDE_BAR_EXTRA_HEIGHT; // px

export const StyledNavbar = styled.nav`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 4;
  height: ${NAV_BAR_HEIGHT}px;
  background-color: ${`${LIGHT_BACKGROUND_COLOR}c7`};
  padding: 0 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: top 0.3s;
  backdrop-filter: blur(8px);

  .list-container {
    max-width: 1000px;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
  }

  ul {
    display: flex;
    list-style-type: none;

    li {
      margin-right: 70px;

      a {
        padding: 10px 0;
        color: ${PRIMARY_COLOR};
        text-decoration: none;
        font-size: 14px;
        font-weight: ${SEMI_BOLD_FONT};
        transition: opacity 0.3s;

        &:hover {
          opacity: 0.7;
        }
      }
    }
  }

  .resume-btn {
    background-color: ${PRIMARY_COLOR};
    color: #ffffff;
    padding: 10px 20px;
    border-radius: 50px;
    border: 2px solid #ffffff;
    font-weight: ${SEMI_BOLD_FONT};
    font-size: 14px;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.3s;

    &:hover {
      background-color: #ffffff;
      color: ${PRIMARY_COLOR};
      border-color: ${PRIMARY_COLOR};
    }
  }

  .menu-btn {
    position: absolute;
    width: 50px;
    height: 50px;
    outline: none;
    border: none;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;

    .menu-icon {
      display: inline-block;
      width: 24px;
      height: 2px;
      background-color: ${PRIMARY_COLOR};
      position: relative;

      &::before,
      &::after {
        content: "";
        width: 24px;
        height: 2px;
        background-color: ${PRIMARY_COLOR};
        position: absolute;
        left: 0;
        transition: transform 0.2s;
      }

      &::before {
        top: -6px;
      }

      &::after {
        bottom: -6px;
      }

      &.toggled {
        background-color: transparent;
      }

      &.toggled::before {
        top: 0;
        transform: rotate(135deg);
      }

      &.toggled::after {
        top: 0;
        transform: rotate(-135deg);
      }
    }
  }

  aside {
    position: absolute;
    left: 0;
    right: 0;
    height: ${SIDE_BAR_HEIGHT}px;
    background-color: ${LIGHT_BACKGROUND_COLOR};
    transition: top 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.04);

    .list-container-mobile {
      display: flex;
      flex-direction: column;
      width: 100%;
      justify-content: center;
      align-items: center;
      padding-top: ${NAV_BAR_HEIGHT + SIDE_BAR_EXTRA_HEIGHT}px;
    }

    ul {
      display: block;
      width: 100%;

      li {
        margin: 0 0 24px 0;
        text-align: center;

        a {
          display: block;
          width: 100%;
          font-size: 20px;
        }
      }
    }

    .resume-btn {
      margin-top: 24px;
      font-size: 20px;
    }
  }

  @media (max-width: ${QUERY_IPAD}px) {
    padding: 0 24px;
    justify-content: flex-end;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.04);
  }
`;
